module.exports = __webpack_public_path__ + "img/00000.94424721.webp";